import React, { useState, useEffect } from "react";

const imageExists = async(src) => {
  try {
    const response = await fetch(src, { method: "HEAD" });
    return response.ok;
  } catch (error) {
    return false;
  }
};

export default function Picture({ base, alt, exts, loading, widths, sizes = "", background = "#00000000" }) {
  const [srcSets, setSrcSets] = useState([]);

  useEffect(() => {
    const loadSrcSets = async() => {
      let newSrcSets = [];

      for (const ext of exts) {
        let srcset = "";
        for (const width of widths) {
          const src = `${base}-${width}w.${ext}`;
          if (await imageExists(src)) {
            srcset += `${src} ${width}w, `;
          }
        }

        if (srcset === "") {
          const fallbackSrc = `${base}.${ext}`;
          if (await imageExists(fallbackSrc)) {
            srcset += `${fallbackSrc} 1000w, `;
          }
        }

        srcset = srcset.trim().slice(0, -1);

        newSrcSets.push({
          key: ext,
          srcSet: srcset,
          type: `image/${ext.replace(".", "")}`,
        });
      }

      newSrcSets = newSrcSets.sort((a, b) => {
        if (a.key === "webp") {
          return -1;
        }
        if (b.key === "webp") {
          return 1;
        }
        return 0;
      });

      setSrcSets(newSrcSets);
    };

    loadSrcSets();
  }, [base, exts, widths]);

  return (
    <picture style={{ backgroundColor: background }}>
      {srcSets.map((srcSet) => (
        <source
          key={srcSet.key}
          sizes={sizes}
          srcSet={srcSet.srcSet}
          type={srcSet.type}
        />
      ))}
      <img
        src={srcSets.length > 0 ? srcSets[srcSets.length - 1].srcSet.split(" ")[0] : `${base}.${exts[exts.length - 1]}`}
        alt={alt}
        loading={loading}
      />
    </picture>
  );
}

export function StrapiPicture({picture, alt = "", loading = "lazy", sizes = "100vw"}) {
  let srcsets = [];
  let extensions = {};

  if (picture?.formats){
    for (const [key, format] of Object.entries(picture.formats)){
      if (!extensions[format.ext]){
        extensions[format.ext] = [];
      }
      extensions[format.ext].push(format);
    }

    for (const [key, extension] of Object.entries(extensions)){
      srcsets.push({
        key,
        type: `image/${key?.replace(".", "")}`,
        attribute: extension.map((size) => `${size.url} ${size.width}w`).join(","),
      });
    }
  }

  srcsets = srcsets.sort((a, b) => {
    if (a.key === ".webp"){
      return -1;
    }
    if (b.key === ".webp"){
      return 1;
    }
    return 0;
  });

  return (
    <picture>
      {srcsets.map((srcset) => (
        <source key={srcset.key} sizes={sizes} srcSet={srcset.attribute} type={srcset.type}></source>
      ))}
      <img src={picture?.url} alt={alt} loading={loading} />
    </picture>
  );
}
